import { styled } from "@mui/material";

const StyledMaintenanceBanner = styled("div")({
    backgroundColor: "#233A47",
    color: "#fff",
    padding: "10px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "bold",
    border: "1px solid #2C99D2",
    width: "98%",
    marginLeft: "0.1vw",
});

const MaintenanceBanner = ({ showBanner }) =>
    showBanner && (
        <StyledMaintenanceBanner>
            KMConnect will be undergoing maintenance and unavailable from{" "}
            {window._env_.REACT_APP_MAINTENANCE_TIME_WINDOW} on {window._env_.REACT_APP_MAINTENANCE_DATE}
        </StyledMaintenanceBanner>
    );

export default MaintenanceBanner;
